import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const createCompanyRole = (_, params) => {
  return Api(endPoints.createCompanyRole, params, requestType.POST);
};

const getAllCompanyRole = (id) => {
  return Api(`${endPoints.getAllCompanyRole}/${id}`, null, requestType.GET);
};

const updateCompanyRole = (id, params) => {
  return Api(`${endPoints.updateCompanyRole}/${id}`, params, requestType.PUT);
};

const deleteCompanyRole = (id) => {
  return Api(`${endPoints.deleteCompanyRole}/${id}`, null, requestType.DELETE);
};

export {
  createCompanyRole,
  getAllCompanyRole,
  updateCompanyRole,
  deleteCompanyRole,
};
